import img1 from "../../textiles_png/7_textiles/seven_other/7C4_Kathy Marianito in traditional garb.png";
import img2 from "../../textiles_png/7_textiles/seven_other/7C1-DPLWHG_N-338_Navajo.png";
import img3 from "../../textiles_png/7_textiles/seven_other/7B5_jakeattreasureisland_e.png";
import img4 from "../../textiles_png/7_textiles/seven_other/7B3_ortega--chris.png";
import img5 from "../../textiles_png/7_textiles/seven_other/7B2_P1979-202-241.png";
import img6 from "../../textiles_png/7_textiles/seven_other/7B1_rio_grande_blankets_scan001.png";
import img7 from "../../textiles_png/7_textiles/seven_other/7A2_cordry_414_scan2.png";
import img8 from "../../textiles_png/7_textiles/seven_other/7A2_CL1633.png";
import img9 from "../../textiles_png/7_textiles/seven_other/7A1_2006-339_rodak-weaver_scan1.png";
import img10 from "../../textiles_png/7_textiles/seven_other/7_map.png";
import img11 from "../../textiles_png/7_textiles/seven_other/7_map2.png";
import img12 from "../../textiles_png/7_textiles/seven_other/7_text.png";

export const sevenObj = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: false,
  topLine: "",
  headline: "Saltillo Influence on indigenous communities in North Mexico",
  description:
    "Looms used by Indigenous communities in northwest Mexico and the southwestern United States are different from those used by weavers elsewhere to produce sarapes. Instead of backstrap or treadle looms, they use horizontal looms made of hand-hewn logs. The weavings of the Rarámuri (Tarahumara) Indians in Chihuahua, and Mayo Indians in Sonora and Sinaloa, show the influence of Saltillo sarape designs.",
  description2:
    "In the 1970s, through initiatives by the Mexican government to promote the country’s crafts, and the efforts of American traders to sell northwest Mexican handicrafts, a strong market was created for northern Mexico’s Indigenous weavings.",
  buttonLabel: "",
  imgStart: false,
  imgdesc: "",
  img: img10,
  alt: "One",
  imgdesc2: "Regional Weaving Centers",
  img2: img11,
  alt2: "One",
  imgdesc3: "",
  dark: true,
  primary: true,
  darkText: false,
  smallImg: false,
  margImg: true,
};

export const sevenObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: false,
  topLine: "",
  headline: "The RARÁMURI (Tarahumara)",
  description:
    "The Rarámuri (Tarahumara) live in the remote canyons and highlands of the Sierra Madres in the Mexican state of Chihuahua. Using horizontal looms made of large logs, they weave thick, woolen blankets of loosely hand-spun yarn. The looms have warps (the vertical threads) consisting of one continuous piece of yarn that loops around a log at each end.",
  description2:
    "Designs are simple, and often include Saltillo sarape diamonds in different configurations. Saltillo sarape design elements have been used since at least the late 1800s. The Saltillo influence may have traveled up the Camino Real, the famed trade route between Mexico City and Santa Fe, which ran through parts of Rarámuri traditional territory in eastern Chihuahua. Spanish missions were established among the Rarámuri beginning in the early 1600s, so despite their remote location, they were not cut off from outside influences.",
  buttonLabel: "",
  imgStart: false,
  imgdesc:
    "Notice the diamond pattern on the blanket worn by the man on the left.",
  img: img8,
  alt: "One",
  imgdesc2:
    "Rarámuri group " +
    "Chihuahua, south of Barranca de San Carlos, Mexico Carl Lumholtz, photographer, 1892 " +
    "American Museum of Natural History Research Library, CL1633",
  img2: img9,
  alt2: "One",
  imgdesc3:
    "Rarámuri weaver " +
    "Basiguare, Guachochi, Chihuahua, Mexico Madeleine Rodack, photographer, 1976 ASM 2006-339",
  dark: true,
  primary: true,
  darkText: false,
  smallImg: true,
  margImg: true,
};

export const sevenObjTwo = {
  id: "one",
  lightBg: false,
  lightText: true,
  lightTextDesc: false,
  topLine: "",
  headline: "Mayo",
  description:
    "Mayo Indians (also called Yoreme) live primarily along the Río Mayo and Río Fuerte in the Mexican states of Sonora and Sinaloa. Since Spanish Colonial times, they may have been more fully integrated into mainstream Mexican culture than the Rarámuri were. Nevertheless, Mayos still maintain distinct religious practices along with their own language and craft traditions. Several villages are known for their blanket-weaving expertise.",
  description2:
    "Mayo weavers are almost exclusively women. They use horizontal looms to produce two broad categories of blankets: plain-banded and cobijas, which are mainly woven for the community’s use, and more decorative sarapes, which are primarily woven for trade. In Sinaloa’s Mayo community, a small number of men weave simple blankets on treadle looms.",
  description3:
    "Since at least the late 1800s, Mayo weavers have woven their own version of sarapes with designs clearly connected to Saltillo. These would have been popular items to trade with Mexican residents of the region, including those in the nearby colonial town of Alamos. In the 1940s, this formerly wealthy mining community attracted additional potential craft customers when American tourists “discovered” its charm and created an expatriate community there.",
  buttonLabel: "",
  imgStart: false,
  imgdesc:
    "This Mayo weaver is creating a Saltillo- influenced diamond design.",
  img: img7,
  imgdesc2:
    "Huatabampo, Sonora, Mexico Donald B. Cordry, photographer, 1938 ASM Cordry Collection 414",
  alt: "one",
  dark: true,
  primary: true,
  darkText: false,
  smallImg: false,
  margImg: true,
};

export const sevenObjThree = {
  id: "one",
  lightBg: false,
  lightText: true,
  lightTextDesc: false,
  topLine: "",
  headline: "Saltillo influence in new mexico",
  description:
    "Early settlers to the far northern reaches of New Spain, in what is now New Mexico, brought along the treadle loom and Churro sheep. By the 1630s, European-style treadle looms were made locally and Spanish-style obrajes (workshops) were established. New Mexican weavers adopted the Saltillo design system but enlarged the pattern and initially rendered it less finely.",
  description2:
    "In addition, Spanish and Indian populations were required to make repartimientos (payments) to the Spanish landholders, and textiles were in high demand for this purpose. To ensure the production of textiles, the Spanish government hired skilled artisans from Puebla, Mexico to teach weaving. Master weavers Juan and Ygnacio Bazán, who came to Santa Fe, New Mexico, in 1807, are credited with the introduction of more-complex textile weaving.",
  description3:
    "The Northern Rio Grande Valley has become famous for its textiles. Many of the area’s designs show the influence of the Mexican Saltillo sarape. Today, weaving families, including the Trujillos and Ortegas, continue to promote this traditional art, which is produced in their workshops in Chimayo, and in home workshops by weavers they have taught.",
  buttonLabel: "",
  imgStart: false,
  imgdesc:
    "New Mexican blankets, referred to as Rio Grande blankets, show the influence of the Saltillo sarape design. This shop displayed them outside to attract buyers.",
  img: img6,
  imgdesc2:
    "Chimayo, New Mexico, c. 1900–1905 Prudence Clark Collection, Menaul Historical Library, 1975.001.052",
  alt: "one",
  dark: true,
  primary: true,
  darkText: false,
  smallImg: false,
  margImg: true,
};

export const sevenObjFour = {
  id: "one",
  lightBg: false,
  lightText: true,
  lightTextDesc: false,
  topLine: "",
  headline: "Saltillo influence in new mexico",
  description:
    "The Ortega family traces its history to Gabriel Ortega, who settled in what became Chimayo, New Mexico, in the early 1700s. He wove out of necessity to clothe his family and keep them warm. In the early 1900s, responding to a new tourist market, the Ortega family opened a general store where they sold their weavings, many influenced by the Saltillo sarape design. Today, they continue their family weaving business in Chimayo.",
  buttonLabel: "",
  imgStart: false,
  img: "\n\n",
  img3: img5,
  imgdesc4:
    "Reyes Ortega at his loom Laura Gilpin, photographer, 1939 Chimayo, NM Amon Carter Museum of American Art, P1979.202.241, 1979",
  img2: img4,
  imgdesc3:
    "Chris Ortega, seventh-generation weaver, at his loom Robert Ortega, photographer, 2020",
  alt: "one",
  dark: true,
  primary: true,
  darkText: false,
  smallImg: false,
  margImg: false,
};

export const sevenObjFive = {
  id: "one",
  lightBg: false,
  lightText: true,
  lightTextDesc: false,
  topLine: "",
  headline: "",
  description:
    "Similar to the Ortegas, the Trujillo family’s tradition of weaving goes back eight generations. The family opened Centinela Traditional Arts in 1982 next to their orchard in Chimayo. The shop promotes Irvin and Lisa Trujillo’s award-winning fine-art tapestry pieces, along with textiles in the traditional Chimayo and Rio Grande styles. Tapestry textiles use finer yarns and more warp thread per inch, tend to be more intricate in design, and are usually displayed like artworks on a wall. In 2007, Irvin was named a National Heritage Fellow by the National Endowment for the Arts.",
  quote1:
    "As a seventh-generation Rio Grande weaver living in Chimayo, New Mexico, my work has evolved" +
    "from the traditional styles of my forefathers. I use design ideas from historic Rio Grande weavings of northern New Mexico and add my own aesthetic by combining old ideas with my own vision. My pieces may interpret my Hispanic history and culture, and document events of the modern world.",
  author: "Irvin Trujillo",
  smallDesc:
    "To view weavings by Irvin Trujillo go to: chimayoweavers.com/PORTILT.html",
  buttonLabel: "",
  imgStart: false,
  img: img3,
  imgdesc2:
    "Irvin Trujillo’s father, Jake Trujillo, taught weaving to Navy sailors at Treasure Island, San Francisco, 1944. Photograph courtesy of Trujillo family",
  alt: "one",
  dark: true,
  primary: true,
  darkText: false,
  smallImg: false,
  margImg: true,
};

export const sevenObjSix = {
  id: "one",
  lightBg: false,
  lightText: true,
  lightTextDesc: false,
  topLine: "",
  headline: "Saltillo influence in navajo weaving",
  description:
    "According to traditional stories, Spider Woman wove the universe and then taught the Navajo people to weave in order to achieve hózhó— balance, harmony, beauty, and order. Early Navajo weaving was similar in many ways to that of the nearby Pueblo Indians. They both used upright looms and had been introduced to sheep’s wool and dyes through contact with Spaniards and Mexicans.",
  description2:
    "In the mid-1800s, Navajo weavings begin to show influences from Mexican sarapes, including a longer-than-wide orientation and inclusion of serrate-edged diamonds and vertical zigzags. Textiles from this period also feature stepped and terraced motifs, reflective of early Navajo basketry but also similar to Saltillo design elements. Navajo weavers may have seen Mexican and New Mexican Saltillo- style weavings while imprisoned at Bosque Redondo, in New Mexico, from 1864 to 1868, or even via trading. During that period, Navajo women were encouraged to weave and were supplied with dyed yarns from Germantown, Pennsylvania. Saltillo design elements are still used by Navajo weavers today.",
  buttonLabel: "",
  imgStart: false,
  img: img2,
  imgdesc2:
    "A Navajo woman weaving on an upright, continuous-warp loom. The rug has a centralized diamond design on an open field. Jesse Nusbaum, photographer, c. 1921–1931 Denver Public Library, N-338",
  alt: "one",
  dark: true,
  primary: true,
  darkText: false,
  smallImg: false,
  margImg: true,
};

export const sevenObjSeven = {
  id: "one",
  lightBg: false,
  lightText: true,
  lightTextDesc: false,
  topLine: "",
  headline: "",
  description:
    "Today, Navajo weavers, like their Oaxacan counterparts, continue to be inspired by weavings of the past while also creating innovative new designs. When designing this weaving, Kathy Marianito was inspired by a 1903 Navajo weaving that was sold through a catalog by Indian arts trader J. B. Moore. Both designs pay homage to Classic period Saltillo sarapes.",
  buttonLabel: "",
  imgStart: false,
  img: "",
  img3: img1,
  imgdesc4:
    "At the 2015 Gallup Inter-Tribal Indian Ceremonial, Kathy Marianito was awarded first place in the poncho weavings category for this piece. Steve Getzwiller, Nizhoni Ranch Gallery, photographer, 2015",
  img2: img12,
  imgdesc3:
    "J.B. Moore, The Catalogues of Fine Navajo Blankets, Rugs, Ceremonial Baskets, Silverware, Jewelry & Curios, 1903 and 1911, Plate II",
  alt: "",
  dark: true,
  primary: true,
  darkText: false,
  smallImg: false,
  margImg: true,
};
